
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"fill":"currentColor","fill-opacity":".95","fill-rule":"evenodd","d":"M24 12.01C24 5.377 18.627 0 12 0S0 5.377 0 12.01c0 5.995 4.388 10.964 10.125 11.865v-8.393H7.078V12.01h3.047V9.364c0-3.01 1.792-4.672 4.533-4.672 1.312 0 2.686.234 2.686.234v2.956H15.83c-1.491 0-1.956.926-1.956 1.875v2.253h3.328l-.532 3.472h-2.796v8.393C19.612 22.974 24 18.005 24 12.01"}})])
      }
    
      }
    